import { wait } from '@vend/utilities'
import { refund } from '../../helpers/refund'
import { LSPAYRefundOptions } from '../../helpers/lspay.types'

const MAX_RETRIES = 3

/**
 * Gets the timeout to wait for a retry.
 * Max's out at 4000ms at 3 retries.
 *
 * @param retryAttempt The number of retries we're up to. e.g. 1, 2, 3, 4...
 * @returns The time to wait before making the attempt
 */
const getRetryTimeout = (retryAttempt: number): number => {
  if (retryAttempt < 1) return 0
  switch (retryAttempt) {
    case 1: {
      return 1000
    }
    case 2: {
      return 2000
    }
    default: {
      return 4000
    }
  }
}

/**
 * Try to save a refund in swiper.
 * Has a built in retry mechanism.
 * Retry 3 times, with a wait in between each retry.
 * If it fails after 3 trys throw an error
 *
 * @returns The completed refund transaction
 */
export const persistRefund = async (
  lspayRefundOptions: LSPAYRefundOptions,
  retries?: number
): Promise<any> => {
  // increment the attempt counter or initialize it
  const attemptCounter = retries ? retries + 1 : 1

  try {
    return await refund(lspayRefundOptions)
  } catch (error) {
    // Surpassed max amount of retries throw error
    if (attemptCounter > MAX_RETRIES) {
      throw error
    }
  }

  await wait(getRetryTimeout(attemptCounter))

  return await persistRefund(lspayRefundOptions, attemptCounter)
}
